require('../../modules/es.string.ends-with');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'endsWith');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/string/ends-with.js
// module id = 1227
// module chunks = 1